<template>
    <div class="tournaments-wrapper">
        <Row :gutter="32">
            <i-col :xs="12">
                <Table ref="tournamentTable" :columns="columns" :loading="dataLoading" :data="tournaments" :row-class-name="TournamentRowClassName"  @on-row-click="onTournamentRowClick">
                    <div slot-scope="{ row, index }" slot="action">
                        <Button type="error" size="small" @click="deleteTournament(row,index)">Delete</Button>
                    </div>
                </Table>
            </i-col>
            <i-col :xs="12">
                <div class="add-form">
                    <TournamentForm ref="tournamentForm" @getTournaments="getAllTournaments" @setActive="setActive" :tournaments="tournaments"></TournamentForm>
                </div>
            </i-col>
        </Row>
    </div>
</template>

<script>
    import { bus } from "../../main";
    import { getTournaments, deleteTournament } from "../../_services/tournament.service";
    import TournamentForm from "./TournamentForm"

    export default {
        components:{
            TournamentForm
        },
        data() {
            return {
                dataLoading:false,
                submitLoading:false,
                activeTournament:null,
                columns: [
                    {
                        title: "Existing tournaments",
                        key: "TournamentName"
                    },
                    {
                        title:" ",
                        slot:"action",
                        align:"right",
                        width: "80"
                    }
                ],
                descColumns: [
                    {
                        title: "Language",
                        key: "LanguageName",
                        className: "capitalize",
                        width:"150"
                    },
                    {
                        title: "Description",
                        key: "Description"
                    },
                    {
                        title:" ",
                        slot:"action",
                        align:"right",
                        width: "80"
                    }
                ],
                tournaments:[]
            };
        },
        methods: {
            deleteTournament(data,index) {
                this.$Modal.confirm({
                    title: 'Remove Tournament',
                    content: "Are you sure you want to remove tournament?",
                    okText: 'Remove',
                    cancelText: 'Cancel',
                    onOk: () => {
                        this.dataLoading = true
                        deleteTournament(data._id).then(res => {
                            this.tournaments.splice(index, 1);
                            this.dataLoading = false
                            this.$refs.tournamentForm.resetForm()
                            this.$Message.success(`Successfully deleted tournament ${data.TournamentName}!`);
                        }).catch(err => {
                            this.dataLoading = false
                            this.$Message.error("Failed to remove Tournament. Please try again later.");
                        });
                    },
                });
            },
            getAllTournaments() {
                this.dataLoading=true
                getTournaments().then(res => {
                    this.dataLoading=false
                    this.tournaments=res.data.data
                }).catch(err => {
                    this.dataLoading=false
                    bus.$emit('requestError',err)
                    this.$Message.error("Failed to get tournaments. Please try again later");
                });
            },
            onTournamentRowClick(data,index){
                if(this.activeTournament===index){
                    this.activeTournament=null
                    this.$refs.tournamentForm.resetForm()
                }else {
                    this.$refs.tournamentForm.setUpdateData(data)
                }
            },
            TournamentRowClassName(row, index) {
                if (index === this.activeTournament) {
                    return 'active-table-row';
                }
                return '';
            },
            async setActive(data){
                if(!data){
                    this.activeTournament=null
                }else{
                    let vIndex = this.tournaments.map(function(e) { return e._id; }).indexOf(data._id);
                    if(vIndex===-1){
                        this.activeTournament = null
                    }else {
                        this.activeTournament = await vIndex
                    }
                }
            }

        },
        mounted() {
            this.getAllTournaments()
        }
    };
</script>
<style scoped>
    .tournaments-wrapper{
        width: 1000px;
    }
</style>
